import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { FetchStudBookLanguagethunk } from "../Redux/StudBook/StudBookAction";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
const baseURL = process.env.REACT_APP_BASE_URL;
export const OperatingSystems = Object.freeze({
  WEB: 0,
  IOS: 1,
  ANDROID: 2
});

const Layout = ({ children }) => {
  const [userProfile, setUserProfile] = useState("");
  const { pathname } = useLocation();
  const [agentOS, setIsAndroifOrIOS] = useState(OperatingSystems.WEB);

  // function to catch opareating System
  const detectOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) ||
      (/^((?!chrome|android).)*safari/i.test(userAgent) && !/Android/.test(userAgent));

    if (/android/i.test(userAgent)) {
      setIsAndroifOrIOS(OperatingSystems.ANDROID);
    } else if (isIOS && !window.MSStream) {
      setIsAndroifOrIOS(OperatingSystems.IOS);
    } else {
      setIsAndroifOrIOS(OperatingSystems.WEB);
    }
  };

  useEffect(() => {
    detectOperatingSystem();
  }, []);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidtht, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const { currentLanguage } = useSelector(
    (state) => state.studBookSlice
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(() => {
    dispatch(FetchStudBookLanguagethunk(currentLanguage === "en" ? "1" : "2"));
  }, [currentLanguage]);


  return (
    <div>
      {currentLanguage === 'ar' && false && <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.rtl.min.css" integrity="sha384-gXt9imSW0VcJVHezoNQsP+TNrjYXoGcrqBZJpry9zJt8PCQjobwmhMGaDHTASo9N" crossorigin="anonymous" />}
      {currentLanguage === 'en' && false && <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous" />}
      <link rel="stylesheet" href={`${baseURL}/assets/css/style-prod-v11.css`} />
      {currentLanguage === 'ar' && <link rel="stylesheet" href={`${baseURL}/assets/css/rtl-prod-v3.css`} />}

      {/* Pass setUserProfile as a prop to Header */}
      {pathname != "/m-book-table"
        && pathname != "/m-ads-book-table"
        && pathname != "/m-opend-ads"
        && pathname != "/fullScreenBidding"
        && pathname != "/m-opend-events"
        && pathname != "/pressCoverageRequest"
        && pathname != "/digitalcatalog"
        && pathname != "/poll"
        && pathname != "/m-wahoconference" &&
        <Header setUserProfile={setUserProfile} agentOS={agentOS} />
      }
      {pathname == '/' || pathname =='/calendar' || pathname =='/poll' ?
        <>{children}</>
        :
        <div className={`container py-4 mobile-extra-padding mainLayoutContainer`}>{children}</div>
      }
      {pathname != "/m-book-table"
        && pathname != "/m-ads-book-table"
        && pathname != "/m-opend-ads"
        && pathname != "/fullScreenBidding"
        && pathname != "/m-wahoconference"
        && pathname != "/pressCoverageRequest"
        && pathname != "/digitalcatalog"
        && pathname != "/poll"
        && pathname != "/m-opend-events" &&
        <Footer />
      }
    </div>
  );
};

export default Layout;
